/* eslint-disable camelcase */
import * as Sentry from '@sentry/gatsby';
import axios from '../utils/axios';

const sendEvent = (action, event_type, tool = null) => {
  const data = { action, event_type };

  let url = 'event/track/';
  if (tool) {
    url += `?tool=${tool}`;
  }

  return axios.post(url, data).catch((error) => {
    /* eslint-disable-next-line no-console */
    console.warn(error?.response?.data ?? error);
    Sentry.captureException(error);
    return Promise.reject(error);
  });
};

export default sendEvent;
